<template>
    <div>
        <template v-if="field.type == 'models'">
            <div>
                {{ field.text }}
                <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-on:click="addItem(field.initial, localEditedItem[field.value])"
                >
                    Agregar
                </v-btn>
                <div v-for="(model, index) in existingItems" :key="index">
                    <models-areas-field
                        v-for="modelsField in field.inputs"
                        :key="modelsField.value"
                        :field="modelsField"
                        :localEditedItem="model"
                        :afterDialogOpen="afterDialogOpen"
                    ></models-areas-field>
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-on:click="removeItem(index, localEditedItem[field.value])"
                    >
                        Borrar
                    </v-btn>
                </div>
            </div>
        </template>

        <v-text-field
            v-else-if="!field.type || field.type == 'text'"
            v-model="localEditedItem[field.value]"
            :label="field.text"
        ></v-text-field>
    </div>
</template>

<script>
export default {
    props: ["field", "localEditedItem", "afterDialogOpen"],
    data: () => ({}),
    methods: {
        addItem(initial, array) {
            const cloned = JSON.parse(JSON.stringify(initial))
            array.push(cloned)
        },
        removeItem(index, array) {
            if (array[index].id) {
                array.splice(index, 1, {
                    ...array[index],
                    _destroy: true
                })
            } else {
                array.splice(index, 1)
            }
        }
    },
    computed: {
        existingItems() {
            return this.localEditedItem[this.field.value].filter(item => !item._destroy)
        }
    }
}
</script>
